








































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { TrackFieldsLabels, TrackFields } from '@/constants'
import Axios from 'axios'
import { fileTypeValueGetter } from '@/helpers/ag-grid/valueGetter'
import { getObjectDifference } from '@/helpers/generic'

@Component({
  components: {
    ColorPicker: require('@/components/ColorPicker').default
  }
})
export default class TrackFieldEditorModal extends Vue {
  @Prop({
    required: true
  })
  track: Track | undefined

  @Prop({
    required: true
  })
  disabled: boolean

  model: Track | null = null
  modalOpen: boolean = false
  loading: boolean = false
  labels = TrackFieldsLabels

  get isDisabled(): boolean {
    return this.disabled || !this.track
  }

  get cancelMethods(): string[] | boolean {
    if (this.loading) return false
    else return ['x', 'escape', 'outside']
  }

  get fileType(): string {
    return fileTypeValueGetter({
      data: this.model
    } as any)
  }

  setRatingZero() {
    if (this.model) {
      this.model.rating = 0
    }
  }

  open() {
    if (this.track) {
      this.model = JSON.parse(JSON.stringify(this.track))

      if (this.model && this.model.rating) this.model.rating /= 51
    }

    this.modalOpen = true

    this.$emit('open')
  }

  cancel() {
    if (this.loading) return

    this.modalOpen = false

    this.$emit('close')
  }

  async save() {
    if (this.loading || !this.model) return

    this.loading = true

    const diff = getObjectDifference(this.model, this.track)

    for (const key in diff) {
      if (diff[key] === '') {
        diff[key] = null
      }

      if (key === TrackFields.Rating) {
        diff[key] *= 51
      }
    }

    try {
      const {
        data: { tracks, libraryInvalidatedAt }
      } = await Axios.post('/track/edit', {
        trackId: this.model._id,
        track: diff
      })

      this.$store.commit('library/replaceTracks', {
        tracks,
        libraryInvalidatedAt
      })

      this.$buefy.notification.open('Track saved')

      this.modalOpen = false

      this.$emit('save', tracks[0])
    } catch (error) {
      console.error(error)
    }

    this.loading = false
  }
}
